/**
 * Default concepts list for Impact Assessment Checklist form.
 * Replace with API later.
 */
import type { ChecklistConceptItem } from "./types";

export const DEFAULT_CONCEPTS_LIST: ChecklistConceptItem[] = [
  { id: "pt-biologics", dimension: "Product Type", name: "Biologics" },
  { id: "pt-vaccines", dimension: "Product Type", name: "Vaccines" },
  { id: "pt-small", dimension: "Product Type", name: "Small Molecules" },
  { id: "pt-gene", dimension: "Product Type", name: "Gene Therapy" },
  { id: "pt-cell", dimension: "Product Type", name: "Cell Therapy" },
  { id: "pt-devices", dimension: "Product Type", name: "Medical Devices" },
  { id: "dept-clinical", dimension: "Department", name: "Clinical Development" },
  { id: "dept-doc", dimension: "Department", name: "Document Management" },
  { id: "dept-legal", dimension: "Department", name: "Legal & Compliance" },
  { id: "dept-mfg", dimension: "Department", name: "Manufacturing" },
  { id: "dept-medaff", dimension: "Department", name: "Medical Affairs" },
  { id: "dept-medcom", dimension: "Department", name: "Medical Communications" },
  { id: "dept-pv", dimension: "Department", name: "Pharmacovigilance" },
  { id: "dept-qa", dimension: "Department", name: "Quality Assurance" },
  { id: "dept-qc", dimension: "Department", name: "Quality Control" },
  { id: "dept-ra", dimension: "Department", name: "Regulatory Affairs" },
  { id: "dept-ri", dimension: "Department", name: "Regulatory Intelligence" },
  { id: "dept-sc", dimension: "Department", name: "Supply Chain" },
  { id: "ta-oncology", dimension: "Therapeutic Area", name: "Oncology" },
  { id: "ta-immuno", dimension: "Therapeutic Area", name: "Immunology" },
  { id: "ta-neuro", dimension: "Therapeutic Area", name: "Neurology" },
  { id: "ta-cardio", dimension: "Therapeutic Area", name: "Cardiology" },
  { id: "ta-infect", dimension: "Therapeutic Area", name: "Infectious Diseases" },
  { id: "ta-rare", dimension: "Therapeutic Area", name: "Rare Diseases" },
  {
    id: "ing-api",
    dimension: "Ingredient",
    name: "Active Pharmaceutical Ingredient (API)",
  },
  { id: "ing-excip", dimension: "Ingredient", name: "Excipients" },
  { id: "ing-adj", dimension: "Ingredient", name: "Adjuvants" },
  { id: "ing-pres", dimension: "Ingredient", name: "Preservatives" },
  { id: "ing-buf", dimension: "Ingredient", name: "Buffers" },
  { id: "ing-stab", dimension: "Ingredient", name: "Stabilizers" },
];

export const CONCEPT_CATEGORIES = [
  "All",
  "Product Type",
  "Department",
  "Therapeutic Area",
  "Ingredient",
] as const;
